import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Select } from '@mantine/core'
import { updateRequestQuote } from '../../../services/request-quote'
import { notificationSuccess, notificationError } from '../../ui/Notifications'

const defaultVal = {
  status: 'waiting quote'
}

const defaultStatus = ['finished', 'waiting quote', 'quote ready', 'cancelled']

const FormChangeStatus = ({ dataProductQuote, onCloseModal, reloadList }) => {
  const [formData, setFormData] = useState(defaultVal)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitChangeStatus = async (form) => {
    setLoadingForm(true)
    const payload = {
      status: form.status
    }
    try {
      const response = await updateRequestQuote(dataProductQuote.id, payload)
      if (response.success) {
        onCloseModal()
        reloadList()
        notificationSuccess('Update Product Quote Successfully', 'You have been updated data product quote')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      const captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError('Update Product Quote Error', captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (dataProductQuote) {
      handleSetForm(dataProductQuote)
    }
    // eslint-disable-next-line
  }, [dataProductQuote])

  const handleSetForm = (val) => {
    console.log(val)
    const detail = {
      status: val.status.length > 0 ? `${val.status[0].name}` : null
    }
    setFormData(detail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  return (
    <Box>
      <Box mb='md'>
        <Select
          name='status'
          value={formData.status}
          label='Select Status'
          data={defaultStatus}
          onChange={(val) => handleChangeForm('status', val)}
          size='xs'
          allowDeselect={false}
          withAsterisk
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitChangeStatus(formData)}>Submit</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormChangeStatus